import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, ValidatorFn } from '@angular/forms';

import { IReactiveValidator, IReactiveContext } from "../../reactive-context";

import { ValidationRule, ValidationChanges } from '../models';

export class WrapperValidator implements IReactiveValidator {

    private _validatorFn: ValidatorFn;

    constructor(validatorFn: ValidatorFn) {
        this._validatorFn = validatorFn;
    }

    validate(state: any): boolean {
        return false;
    }
    get error(): string {
        return "";
    }

    get validator(): ValidatorFn {
        return this._validatorFn;
    }
}

@Component({
    selector: 'se-validation-section',
    templateUrl: './se-validation-section.component.html',
    styleUrls: ['./se-validation-section.component.css']
  })
  export class SeValidationSectionComponent implements IReactiveContext<any> {


    private _model: any;
    get model() {
        return this._model;
    }
    get modified() {
        let array = Array.from(this.rules.values());
        return array.some(rule => rule.isModified);
    }
    get modifiedSimple() {
        let array = Array.from(this.rules.values());
        return array.some(rule => rule.isModified);
    }
    get valid() {
        return this.validationModel.valid;
    }
    get validSimple() {
        return this.validationModel.valid;
    }
    get errors() {
        return null;
    }
    get errorsSimple() {
        return null;
    }

    registerProperty(name: string, initialValue: any, selectorPropertyName?: string, validatorsFn?: Array<IReactiveValidator>) {

        let formControl = new FormControl(initialValue, validatorsFn.every(validator => (validator as WrapperValidator) != null) ? validatorsFn.map(validator => (validator as WrapperValidator).validator) : null);
        this.validationModel.addControl(name, formControl);

        let validationRule = new ValidationRule(name, formControl, initialValue);
        this.rules.set(name, validationRule);
    }

    registerComplexProperty(name: string, reactiveContext: IReactiveContext<any>) {
        // This is intentional
    }

    unregisterProperty(name: string) {
        return this.rules.get(name);
    }
    unregisterProperties() {
        this.rules.clear();
    }

    property(name: string) {
        return this.rules.get(name);
    }

    bindToView() {
        // This is intentional
    }

    bindToModel() {
        // This is intentional
    }

    // events

    //model: any;

    @Output()
    validationStatusChange: EventEmitter<ValidationChanges> = new EventEmitter<ValidationChanges>();

    @Output()
    submit: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

    // data members

    @Input()
    validationModel: FormGroup;

    get isModified() {
        let array = Array.from(this.rules.values());
        return array.some(rule => rule.isModified);
    }

    get isValid() {
        return this.validationModel.valid;
    }

    private rules: Map<string, ValidationRule> = new Map<string, ValidationRule>();

    // constructor

    constructor(public formBuilder: FormBuilder) {

        this.validationModel = this.createValidationGroup();

        this.validationModel.valueChanges.subscribe(value => {

            let propertyNames = Object.getOwnPropertyNames(value);

            propertyNames.forEach(propertyName => {

                let changedValidationRule = this.rule(propertyName);

                if (changedValidationRule != null && changedValidationRule.oldValue != changedValidationRule.newValue) {

                    if (this.model != null && changedValidationRule.isValid)
                        this.model[changedValidationRule.name] = changedValidationRule.newValue;

                    let validationChanges = new ValidationChanges(changedValidationRule, this.isValid, this.isModified, this.model);
                    this.validationStatusChange.emit(validationChanges);
                }
            });
        });
    }

    // public functions

    rule(name: string) {
        return this.rules.get(name);
    }

    addRule(name: string, initialState?: any, validatorsFn?: Array<ValidatorFn>) {

        let formControl = new FormControl(initialState, validatorsFn);
        this.validationModel.addControl(name, formControl);

        let validationRule = new ValidationRule(name, formControl, initialState);
        this.rules.set(name, validationRule);
    }

    removeRule(name: string) {
        this.rules.delete(name);
    }

    removeRules() {
        this.rules.clear();
    }

    setRuleValue(name: string, value: any) {

        // let formControl = new FormControl(value, null);
        // this.validationModel.setControl(name, formControl);

        // let validationRule = new ValidationRule(name, formControl, value);
        // this.rules.set(name, validationRule);
    }

    registerModel(model: any) {
        this._model = model;
    }

    onSubmit() {

        this.submit.emit(this.validationModel);
    }

    // protected functions

    protected createValidationGroup(): FormGroup {

        return this.formBuilder.group({});
    }
}
